// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WJmA","colMin":"styles_colMin__34t9c"};